import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getOneTrialResult } from 'api/requests';

export const fetchOneTrialResult = createAsyncThunk(
    'oneTrialResult/fetchOneTrialResult',
    async ({ slug, language = 'en', country = 'en' } = {}) => {
        try {
            const response = await getOneTrialResult(slug, language, country);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);

const oneTrialResultSlice = createSlice({
    name: 'oneTrialResult',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchOneTrialResult.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOneTrialResult.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchOneTrialResult.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default oneTrialResultSlice.reducer;
